/**
 * @desc Controller for the csBreadcrumbsNav directive
 */
;(function () {
  angular
    .module('contrast.breadcrumbs-nav')
    .controller('csBreadcrumbsNavCtrl', csBreadcrumbsNavCtrl)

  function csBreadcrumbsNavCtrl(
    $timeout,
    $location,
    $routeSegment,
    csBreadcrumbsNavTypes,
    csBreadcrumbsNavService
  ) {
    'ngInject'

    var vm = this,
      circlesData = [],
      routeCount = 0,
      svgContainer = null,
      circles = null,
      scope = null,
      separation = 40,
      navType = csBreadcrumbsNavTypes.large

    angular.extend(vm, {
      knobSettings: csBreadcrumbsNavService.getDefaultKnobSettings()
    })

    angular.extend(vm, {
      activate: activate,
      setRoutes: setRoutes,
      setCircleAttrs: setCircleAttrs
    })

    function activate(currentScope, type) {
      scope = currentScope
      navType = type
      if (navType == csBreadcrumbsNavTypes.small) {
        separation = 60
      }
    }

    function setRoutes(routes, initialRouteIndex, clickFn) {
      routeCount = routes.length
      if (!routeCount) {
        return
      }
      circlesData = csBreadcrumbsNavService.getCircles(
        routes,
        initialRouteIndex,
        separation,
        clickFn
      )

      svgContainer = d3
        .select('#nav-breadcrumbs')
        .append('svg')
        .attr('width', 100)
        .attr('height', routeCount * separation - 20)

      if (navType == csBreadcrumbsNavTypes.small) {
        svgContainer
          .append('line')
          .attr('x1', 10)
          .attr('y1', 50)
          .attr('x2', (routeCount - 1) * separation + 10)
          .attr('y2', 50)
          .attr('stroke-width', 1)
      }

      circles = svgContainer
        .selectAll('circle')
        .data(circlesData)
        .enter()
        .append('circle')

      circles.on('click', function (d) {
        if (d.enabled) {
          $location.path(d.url)
          scope.$apply()
          if (angular.isFunction(d.clickFn)) {
            d.clickFn()
          }
        }
      })

      $timeout(function () {
        setCircleAttrs()
      })
    }

    function setCircleAttrs() {
      if (isHorizontal()) {
        d3.select('#nav-breadcrumbs')
          .select('svg')
          .attr('width', (routeCount - 1) * separation + 20)
          .attr('height', 100)
      } else {
        d3.select('#nav-breadcrumbs')
          .select('svg')
          .attr('width', 100)
          .attr('height', routeCount * separation - 20)
      }

      var activeIndex = 0
      angular.forEach(circlesData, function (circle, index) {
        if (index < routeCount) {
          var active = $routeSegment.name === circle.link
          if (active) {
            activeIndex = index
          }
        }
      })

      vm.knobSettings.value = getKnobValue(activeIndex + 1)

      circlesData[routeCount].link = circlesData[activeIndex].link
      circlesData[routeCount].url = circlesData[activeIndex].url

      var activeCircle = d3.select('circle.active')
      if (!activeCircle.empty()) {
        if (isHorizontal()) {
          activeCircle
            .transition()
            .attr('cx', 10 + activeIndex * separation)
            .duration(500)
            .each('end', function () {
              circlesData[routeCount].cy = 10 + activeIndex * separation
            })
        } else {
          activeCircle
            .transition()
            .attr('cy', 10 + activeIndex * separation)
            .duration(500)
            .each('end', function () {
              circlesData[routeCount].cy = 10 + activeIndex * separation
            })
        }
      } else {
        circlesData[routeCount].cy = 10 + activeIndex * separation
      }

      circles
        .attr('fill-opacity', function (d) {
          if (d.active) {
            if (d.loaded) {
              return 0.75
            }
            return 0
          }

          return 1
        })
        .attr('cx', function (d) {
          if (isHorizontal()) {
            return d.cy
          }
          return d.cx
        })
        .attr('cy', function (d) {
          if (isHorizontal()) {
            return d.cx
          }
          return d.cy
        })
        .attr('r', function (d) {
          return d.r
        })
        .attr('class', function (d) {
          var classes = ''

          if (d.active) {
            classes += 'active '
          } else if (d.enabled) {
            classes += 'active-link '
          }

          var linkActive = d.linkActive
          classes += linkActive ? ' active-link' : ''

          return classes
        })

      activeCircle = d3.select('circle.active')
      if (!activeCircle.empty() && !circlesData[routeCount].loaded) {
        activeCircle
          .transition()
          .attr('fill-opacity', 0.75)
          .duration(500)
          .each('end', function () {
            circlesData[routeCount].loaded = true
          })
      }
    }

    function getKnobValue(index) {
      var max = vm.knobSettings.options.max
      return (index / routeCount) * max
    }

    function isHorizontal() {
      // TODO:CONTRAST-16046 When matchMedia is moved into a service, remove this eslint disable comment and inject the service
      // eslint-disable-next-line no-undef
      var matches = matchMedia('screen and (max-width: 992px)').matches
      return navType == csBreadcrumbsNavTypes.small || matches
    }
  }
})()
